import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import type { ICreatePromotionPayload, IPromotion } from '@/interfaces';
import routes from '@/lib/routes';
import { useUserConnected } from '@/hooks';

type TParams = {
	onSuccess?: () => void;
};

export const useRequestCreatePromotion = (params?: TParams) => {
	const { userConnected } = useUserConnected();
	const { isPending, error, mutateAsync } = useMutation({
		mutationKey: [routes.api.promotions.create],
		mutationFn: (data: ICreatePromotionPayload) => {
			return apiClient.axiosInstance
				.post<IPromotion>(routes.api.promotions.create, data, {
					headers: userConnected?.token ? { Authorization: `Bearer ${userConnected.token}` } : {}
				})
				.then(res => res.data)
				.catch(error => {
					throw error?.response?.data ?? error;
				});
		},
		onSuccess: () => params?.onSuccess?.()
	});

	return {
		isLoading: isPending,
		triggerCreatePromotion: (data: ICreatePromotionPayload) => mutateAsync(data),
		error
	};
};
